import React from 'react';
import styled from '@emotion/styled';

interface KeyVisualProps {
  className?: string;
  backgroundImageSrc?: string;
  backgroundImageAlt?: string;
}
const KeyVisual: React.FC<KeyVisualProps> = ({
  className,
  backgroundImageSrc,
  backgroundImageAlt,
  children,
}) => {
  return (
    <Container className={className}>
      {children && <ContentsLayer>{children}</ContentsLayer>}
      {backgroundImageSrc && <BackgroundImage src={backgroundImageSrc} alt={backgroundImageAlt} />}
    </Container>
  );
};

export default KeyVisual;

const Container = styled('header')({
  position: 'relative',
});

const BackgroundImage = styled('img')({
  width: '100%',
});

const ContentsLayer = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
});
